import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Modal, Alert, Button} from 'react-bootstrap'
import loading from '../../assets/loading.svg'
import {deslectEwUser} from '../action/userActions'
import {withRouter} from 'react-router-dom'
import {getUsers} from '../action/userActions'
import userRole from './userRole';


class CreateUserResultModal extends Component{
       render(){

        const SuccessCreate = (()=>{
            return (<div>
                 <p>
                IDEA Connector user has successfully created!
            </p>
            <hr />
            <p className="mb-0">
               Some more user info...something about an email...
            </p>
            </div>)
        })

        const SuccessUpdate = (()=>{
            return (<div>
                 <p>
                IDEA Connector user has successfully updated!
            </p>
            <hr />
            <p className="mb-0">
               Some more user info...something about an email...
            </p>
            </div>)
        })

        const SuccessDelete = (()=>{
            return (<div>
                 <p>
                IDEA Connector user has successfully deleted!
            </p>
            <hr />
            <p className="mb-0">
       
            </p>
            </div>)
        })

        const Error = (()=>{
            return (<div>
                 <p>
                An error has occurred ! :(
            </p>
            <hr />
            <p className="mb-0">
               {this.props.error}
            </p>
            </div>)
        })

        const Warning = (()=>{
            return (<div>
                 <p>
                An error has occurred ! :(
            </p>
            <hr />
            <p className="mb-0">
               Some more user info...something about an email...
            </p>
            </div>)
        })

        const Body = (()=>{
            if(this.props.loading){
                return (<img style={{width : '100%'}} src={loading } />
                )
            }
            if(this.props.action == 'create'){
                return (  this.props.status == 'success' ? <SuccessCreate /> : <Error />
                )
            }
            else
            if(this.props.action == 'update'){
                return (  this.props.status == 'success' ? <SuccessUpdate /> : <Error />
                )
            }
            else{
                return (  this.props.status == 'success' ? <SuccessDelete /> : <Error />
                )
            }
        })


        return (
            <Modal show={this.props.show}>
            <Modal.Body>

            <Alert variant={this.props.variant}>
            <Alert.Heading>{this.props.delete ? 'Delete User Result' : 'Create User Result'}</Alert.Heading>
            <Body />
             </Alert>

            </Modal.Body>
  
            <Modal.Footer>
                <Button onClick={()=>{
                    this.props.dispatch(deslectEwUser())
                    this.props.dispatch(getUsers())
                    this.props.dismiss()
                    this.props.history.push('/')
                    }} variant='info'>Dismiss</Button>
                
            </Modal.Footer>
            </Modal>
        )}
}

const mapStateToProps = state => (
    {
    selectedCo : state.acct.ewCo.selected,
    selectedGroup : state.acct.ewGroup.selected,
    userResult : state.acct.user.createResult,
    loading : state.acct.user.loading,
    error : state.acct.user.error
  });

export default withRouter(connect(mapStateToProps)(CreateUserResultModal))

